/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {Devices, DownloadJob} from '@ion/core/src/types/entities';
import {DisableAccountChooser} from '@ion/dls/src/editors/GroupChooser';
import {SelectAllSearch} from '@ion/features/src/search/types';
import {JobCreateEditor} from '../../components/jobs/JobCreateEditor';
import {
  JobDeviceFileTypeChooserPermissionsProps
} from '../../components/jobs/JobTaskDeviceFileTypeChooser';
import {JobSearchEngine} from './DeviceActionDialogs';

export interface CreateJobEditorProps extends
  JobDeviceFileTypeChooserPermissionsProps,
  DisableAccountChooser,
  SelectAllSearch,
  JobSearchEngine {
  onCloseDialog?: () => void;
  selected?: Devices;
  selectedJob?: DownloadJob;
  includeSubAccounts?: boolean;
  enableAddDevices?: boolean;
}

/**
 * The Create Job editor with set fields and encapsulated logic
 * for handling the form's state, including validation.
 *
 * @param {Function} onCloseDialog: Callback function fired when the dialog requests to be closed
 * @param {Devices} selectedDevices: selected Devices to perform create job operation
 */
export const CreateJobEditor = ({
  Features,
  onCloseDialog,
  filters,
  search,
  selectedJob,
  selected = [],
  enableAddDevices = false,
  areTotalRowsSelected = false,
  totalRowsCount = 0,
  includeSubAccounts = false,
  disableAccountChooser = false,
  jobSearchEngineEnabled = false,
  jobNotificationsBanner,
  jobNotificationsToggle
}: CreateJobEditorProps) => {
  return (
    <JobCreateEditor onCloseDialog={onCloseDialog}
      selectedDevices={selected}
      selectedJob={selectedJob}
      filters={filters}
      Features={Features}
      search={search}
      areTotalRowsSelected={areTotalRowsSelected}
      totalRowsCount={totalRowsCount}
      includeSubAccounts={includeSubAccounts}
      jobSearchEngineEnabled={jobSearchEngineEnabled}
      jobNotificationsBanner={jobNotificationsBanner}
      jobNotificationsToggle={jobNotificationsToggle}
      disableAccountChooser={disableAccountChooser} />
  );
};

export default CreateJobEditor;
